module.exports = __webpack_public_path__ + "img/log-hours.c8cbd313.svg";